import React, {useEffect, useState} from "react";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";

import TextField from "@material-ui/core/TextField";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Typography from "@material-ui/core/Typography";
import {Box, makeStyles} from "@material-ui/core";
import {toggleButton} from "../../../../../utils/componentutils/ToggleButton";
import TreeView from "@material-ui/lab/TreeView";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
import {
    CreateTacticTextField,
    CreateTacticTreeItem,
} from "./CreateTradePlanTree";
import Grid from "@material-ui/core/Grid";
import ApplyRounding from "../../../../../utils/math/ApplyRounding";

const useStyles = makeStyles({
    root: {
        //height: 216,
        //flexGrow: 1,
        //maxWidth: 400,
    },
    expanded: {
        color: "green",
    },
});

const boxProps = {
    bgcolor: "background.paper",
    m: 1,
    borderColor: "text.primary",
};

const tightSpreadPctId = "tightSpreadPct";
const tightSpreadCentsId = "tightSpreadCents";
const optionPriceRangeId = "optionPriceRangeId";
const dollarRangeId = "dollarRangeId";
const qtyRangeId = "qtyRangeId";

const OptionsFiltersTree = (props) => {
    const [
        tightSpreadPctEnabled,
        setTightSpreadPctEnabled,
        tightSpreadPct,
        dispatchTightSpreadPct,
    ] = props.tightSpreadPct;

    const [
        tightSpreadCentsEnabled,
        setTightSpreadCentsEnabled,
        tightSpreadCents,
        dispatchTightSpreadCents,
    ] = props.tightSpreadCents;

    const [
        optionPriceRangeEnabled,
        setOptionPriceRangeEnabled,
        optionPriceRange,
        dispatchOptionPriceRange,
    ] = props.optionPriceRange;

    const [
        qtyRangeEnabled,
        setQtyRangeEnabled,
        qtyRange,
        dispatchQtyRange,
    ] = props.qtyRange;

    const [
        dollarRangeEnabled,
        setDollarRangeEnabled,
        dollarRange,
        dispatchDollarRange,
    ] = props.dollarRange;

    let expanded = [];
    let selected = [];
    //useEffect(() => {
    let anySelected = false;
    if (tightSpreadPctEnabled) {
        expanded.push(tightSpreadPctId);
        selected.push(tightSpreadPctId);
        anySelected = true;
    }
    if (tightSpreadCentsEnabled) {
        expanded.push(tightSpreadCentsId);
        selected.push(tightSpreadCentsId);
        anySelected = true;
    }
    if (optionPriceRangeEnabled) {
        expanded.push(optionPriceRangeId);
        selected.push(optionPriceRangeId);
        anySelected = true;
    }
    if (qtyRangeEnabled) {
        expanded.push(qtyRangeId);
        selected.push(qtyRangeId);
        anySelected = true;
    }
    if (dollarRangeEnabled) {
        expanded.push(dollarRangeId);
        selected.push(dollarRangeId);
        anySelected = true;
    }
    if (anySelected) {
        expanded.push("optionFilters");
        selected.push("optionFilters");
    }

    return (
        <BuildTree
            top={props.top}
            tightSpreadPct={props.tightSpreadPct}
            tightSpreadCents={props.tightSpreadCents}
            optionPriceRange={props.optionPriceRange}
            qtyRange={props.qtyRange}
            dollarRange={props.dollarRange}
            alreadyExpanded={expanded}
            alreadySelected={selected}
            startExpanded={props.startExpanded}
            optionsAvailable={props.optionsAvailable}
        />
    );
};
const BuildTree = (props) => {
    const classes = useStyles();
    const [
        tightSpreadPctEnabled,
        setTightSpreadPctEnabled,
        tightSpreadPct,
        dispatchTightSpreadPct,
    ] = props.tightSpreadPct;

    const [
        tightSpreadCentsEnabled,
        setTightSpreadCentsEnabled,
        tightSpreadCents,
        dispatchTightSpreadCents,
    ] = props.tightSpreadCents;

    const [
        optionPriceRangeEnabled,
        setOptionPriceRangeEnabled,
        optionPriceRange,
        dispatchOptionPriceRange,
    ] = props.optionPriceRange;

    const [
        qtyRangeEnabled,
        setQtyRangeEnabled,
        qtyRange,
        dispatchQtyRange,
    ] = props.qtyRange;

    const [
        dollarRangeEnabled,
        setDollarRangeEnabled,
        dollarRange,
        dispatchDollarRange,
    ] = props.dollarRange;

    const top = props.top;
    const isQtyQuantityBasis = top.quantityBasis === "QUANTITY";

    var [expanded, setExpanded] = useState([]);
    var [selected, setSelected] = useState([]);
    var [seeOptionFilters, setSeeOptionFilters] = useState(props.startExpanded);

    props.alreadyExpanded.forEach((id) => {
        expanded.push(id);
    });
    props.alreadySelected.forEach((id) => {
        selected.push(id);
    });

    const optionFilters = {};
    optionFilters["optionFilters"] = [seeOptionFilters, setSeeOptionFilters];

    optionFilters[tightSpreadPctId] = [
        tightSpreadPctEnabled,
        setTightSpreadPctEnabled,
    ];
    optionFilters[tightSpreadCentsId] = [
        tightSpreadCentsEnabled,
        setTightSpreadCentsEnabled,
    ];
    optionFilters[optionPriceRangeId] = [
        optionPriceRangeEnabled,
        setOptionPriceRangeEnabled,
    ];
    optionFilters[qtyRangeId] = [qtyRangeEnabled, setQtyRangeEnabled];
    optionFilters[dollarRangeId] = [dollarRangeEnabled, setDollarRangeEnabled];

    if (!seeOptionFilters) {
        selected = selected.filter((id) => id !== "optionFilters");
        expanded = expanded.filter((id) => id !== "optionFilters");
    }

    let selectedChanged = false;
    let expandedChanged = false;
    selected = selected.filter((id) => {
        const [tacticEnabled, setTacticEnabled] = optionFilters[id];
        if (!tacticEnabled) {
            selectedChanged = true;
            return false;
        } else {
            return true;
        }
    });
    if (selectedChanged) {
        setSelected(selected);
    }
    expanded = expanded.filter((id) => {
        const [strategyEnabled, setStrategyEnabled] = optionFilters[id];
        if (!strategyEnabled) {
            expandedChanged = true;
            return false;
        } else {
            return true;
        }
    });
    if (expandedChanged) {
        setExpanded(expanded);
    }

    const handleToggle = (event, nodeIds) => {
        setExpanded(nodeIds);
    };

    const handleSelect = (event, nodeId) => {
        let [optionFilterEnabled, setOptionFilterEnabled] = optionFilters[nodeId];
        setOptionFilterEnabled(toggleButton(optionFilterEnabled));
        setSelected(nodeId);
    };

    let MaxQtyBasisComponent = undefined;
    //console.log(top.quantityBasis);
    if (top.quantityBasis === "DOLLARS") {
        setDollarRangeEnabled(false);
        MaxQtyBasisComponent = (
            <CreateTacticTreeItem
                classes={classes}
                tacticComponent={
                    <QtyRangeComponent
                        qtyRange={qtyRange}
                        dispatchQtyRange={dispatchQtyRange}
                    />
                }
                docs={QtyRangeDocumentation}
                nodeId={qtyRangeId}
                label="qty range"
                tacticEnabledHook={[qtyRangeEnabled, setQtyRangeEnabled]}
            />
        );
    } else if (top.quantityBasis === "QUANTITY") {
        setQtyRangeEnabled(false);
        MaxQtyBasisComponent = (
            <CreateTacticTreeItem
                classes={classes}
                docs={DollarRangeDocumentation}
                tacticComponent={
                    <DollarRangeComponent
                        dollarRange={dollarRange}
                        dispatchDollarRange={dispatchDollarRange}
                    />
                }
                nodeId={dollarRangeId}
                label="dollar range"
                tacticEnabledHook={[dollarRangeEnabled, setDollarRangeEnabled]}
            />
        );
    }
    return (
        <div>
            <TreeView
                className={classes.root}
                defaultCollapseIcon={<ExpandMoreIcon/>}
                defaultExpandIcon={<ChevronRightIcon/>}
                multiSelect
                expanded={expanded}
                selected={selected}
                onNodeToggle={handleToggle}
                onNodeSelect={handleSelect}
            >
                <TreeItem
                    nodeId="optionFilters"
                    label={
                        <Typography
                            style={{fontSize: 13, ...((top.symbol !== "" && props.optionsAvailable === 0) && {color: "red"})}}>option
                            filters {props.optionsAvailable !== undefined ? "(" + (props.optionsAvailable) + ")" : ""}</Typography>
                    }
                >
                    <CreateTacticTreeItem
                        classes={classes}
                        docs={TightSpreadPctDocumentation}
                        tacticComponent={
                            <TightSpreadPctComponent
                                tightSpreadPct={tightSpreadPct}
                                dispatchTightSpreadPct={dispatchTightSpreadPct}
                            />
                        }
                        nodeId={tightSpreadPctId}
                        label="tightSpreadPct"
                        tacticEnabledHook={[
                            tightSpreadPctEnabled,
                            setTightSpreadPctEnabled,
                        ]}
                    />
                    <CreateTacticTreeItem
                        classes={classes}
                        tacticComponent={
                            <TightSpreadCentsComponent
                                tightSpreadCents={tightSpreadCents}
                                dispatchTightSpreadCents={dispatchTightSpreadCents}
                            />
                        }
                        nodeId={tightSpreadCentsId}
                        label="tightSpreadCents"
                        docs={TightSpreadCentsDocumentation}
                        tacticEnabledHook={[
                            tightSpreadCentsEnabled,
                            setTightSpreadCentsEnabled,
                        ]}
                    />
                    <CreateTacticTreeItem
                        classes={classes}
                        tacticComponent={
                            <OptionPriceRangeComponent
                                optionPriceRange={optionPriceRange}
                                dispatchOptionPriceRange={dispatchOptionPriceRange}
                            />
                        }
                        docs={OptionPriceRangeDocs}
                        nodeId={optionPriceRangeId}
                        label="price range"
                        tacticEnabledHook={[
                            optionPriceRangeEnabled,
                            setOptionPriceRangeEnabled,
                        ]}
                    />
                    {MaxQtyBasisComponent}
                </TreeItem>
            </TreeView>
        </div>
    );
};

const DollarRangeComponent = ({dollarRange, dispatchDollarRange}) => {
    return (
        <>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="stretch"
                border={1}
                {...boxProps}
            >
                <CreateTacticTextField
                    label="min dollar"
                    defaultValue={parseFloat(dollarRange.minDollar)}
                    onBlurFunc={(ev) =>
                        dispatchDollarRange({
                            minDollar: ev.target.value,
                        })
                    }
                    props={{endAdornment: "$"}}
                />
            </Box>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="stretch"
                border={1}
                {...boxProps}
            >
                <CreateTacticTextField
                    label="max qty"
                    defaultValue={parseFloat(dollarRange.maxDollar)}
                    onBlurFunc={(ev) =>
                        dispatchDollarRange({
                            maxDollar: ev.target.value,
                        })
                    }
                    props={{endAdornment: "$"}}
                />
            </Box>
        </>
    );
};

export const OptionPriceRangeDocs = (
    <html>
    Filter all options that don't fall between the min and the max price
    provided.
    </html>
);

export const DollarRangeDocumentation = (
    <html>
    Filter options based on your qty quantity basis in an entry tactic and the
    min and max dollars you provide.
    <br></br>
    Ex:
    <br></br>
    Let's say you have a market order tactic with a quantityBasisValue of 5. If
    you set the min dollar to 2000 and the max qty to 2500, it will filter all
    options that do not have a midpoint between the bid and the ask between 4
    (4*100*5) and 5 (5*100*5)
    </html>
);

export const QtyRangeDocumentation = (
    <html>
    Filter options based on your dollar quantity basis in an entry tactic and
    the min and max qty you provide.
    <br></br>
    Ex:
    <br></br>
    Let's say you have a market order tactic with a quantityBasisValue of 1500$.
    If you set the min qty to 3 and the max qty to 5, it will filter all options
    that do not have a midpoint between the bid and the ask between 3 (5*100*3)
    and 5 (3*100*5)
    </html>
);

export const TightSpreadCentsDocumentation = (
    <html>
    Filter all options in which the difference between the spread and the ask do
    not pass this filter.
    <br></br>
    If you set this to .25, all options that have a spread wider than that, such
    as one with a bid of 7.45 and an ask of 7.75, will be filtered.
    </html>
);

export const TightSpreadPctDocumentation = (
    <html>
    Filter all options in which the spread and the ask do not pass this filter.
    <br></br>
    If you set this to 5%, all options that have a spread wider than that, such
    as one with a bid of 1.45 and an ask of 1.53, will be filtered.
    </html>
);
const QtyRangeComponent = ({qtyRange, dispatchQtyRange}) => {
    return (
        <>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="stretch"
                border={1}
                {...boxProps}
            >
                <CreateTacticTextField
                    label="min qty"
                    defaultValue={parseFloat(qtyRange.minQty)}
                    onBlurFunc={(ev) =>
                        dispatchQtyRange({
                            minQty: ev.target.value,
                        })
                    }
                    props={{
                        endAdornment: (
                            <Typography style={{fontSize: 6}}>contracts</Typography>
                        ),
                    }}
                />
            </Box>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="stretch"
                border={1}
                {...boxProps}
            >
                <CreateTacticTextField
                    label="max qty"
                    defaultValue={parseFloat(qtyRange.maxQty)}
                    onBlurFunc={(ev) =>
                        dispatchQtyRange({
                            maxQty: ev.target.value,
                        })
                    }
                    props={{
                        endAdornment: (
                            <Typography style={{fontSize: 6}}>contracts</Typography>
                        ),
                    }}
                />
            </Box>
        </>
    );
};

const TightSpreadPctComponent = ({
                                     tightSpreadPct,
                                     dispatchTightSpreadPct,
                                 }) => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="stretch"
            border={1}
            {...boxProps}
        >
            <CreateTacticTextField
                label="max spread pct"
                defaultValue={ApplyRounding(
                    parseFloat(tightSpreadPct.maxOptionSpreadPct) * 100,
                    2
                )}
                onBlurFunc={(ev) =>
                    dispatchTightSpreadPct({
                        maxOptionSpreadPct: ApplyRounding(
                            parseFloat(ev.target.value) / 100,
                            4
                        ),
                    })
                }
                props={{endAdornment: "%"}}
            />
        </Box>
    );
};

const TightSpreadCentsComponent = ({
                                       tightSpreadCents,
                                       dispatchTightSpreadCents,
                                   }) => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="stretch"
            border={1}
            {...boxProps}
        >
            <CreateTacticTextField
                label="max spread cents"
                defaultValue={ApplyRounding(
                    parseFloat(tightSpreadCents.maxOptionSpreadCents),
                    2
                )}
                onBlurFunc={(ev) =>
                    dispatchTightSpreadCents({
                        maxOptionSpreadCents: ApplyRounding(parseFloat(ev.target.value), 2),
                    })
                }
                props={{endAdornment: "$"}}
            />
        </Box>
    );
};

const OptionPriceRangeComponent = ({
                                       optionPriceRange,
                                       dispatchOptionPriceRange,
                                   }) => {
    return (
        <Grid item container>
            <Grid item xs={6}>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="stretch"
                    border={1}
                    {...boxProps}
                >
                    <CreateTacticTextField
                        label="min"
                        defaultValue={optionPriceRange.minPrice}
                        onBlurFunc={(ev) =>
                            dispatchOptionPriceRange({
                                minPrice: ev.target.value,
                            })
                        }
                    />
                </Box>
            </Grid>
            <Grid item xs={6}>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="stretch"
                    border={1}
                    {...boxProps}
                >
                    <CreateTacticTextField
                        label="max"
                        defaultValue={optionPriceRange.maxPrice}
                        onBlurFunc={(ev) =>
                            dispatchOptionPriceRange({
                                maxPrice: ev.target.value,
                            })
                        }
                    />
                </Box>
            </Grid>
        </Grid>
    );
};
const OptionsFilters = (props) => {
    const [
        tightSpreadPctEnabled,
        setTightSpreadPctEnabled,
        tightSpreadPct,
        dispatchTightSpreadPct,
    ] = props.tightSpreadPct;

    const [
        optionPriceRangeEnabled,
        setOptionPriceRangeEnabled,
        optionPriceRange,
        dispatchOptionPriceRange,
    ] = props.optionPriceRange;
    const top = props.top;
    const isQtyQuantityBasis = top.quantityBasis === "QUANTITY";

    return (
        <React.Fragment>
            <Typography variant="h6" color="textSecondary">
                Option Filters
            </Typography>
            <Accordion expanded={tightSpreadPctEnabled}>
                <AccordionSummary
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                >
                    <FormControlLabel
                        aria-label="Acknowledge"
                        // onClick={(event) => event.stopPropagation()}
                        // onFocus={(event) => event.stopPropagation()}
                        // expanded={expanded === "additional"}
                        // onClick={(ev) => handleChange("additional")}
                        label="Add tight spread"
                        control={
                            <Checkbox
                                checked={tightSpreadPctEnabled}
                                onChange={(ev) =>
                                    setTightSpreadPctEnabled(tightSpreadPctEnabled !== true)
                                }
                            />
                        }
                    />
                </AccordionSummary>
                <AccordionDetails>
                    <TextField
                        id="outlined-basic"
                        label="Max Option Spread"
                        variant="outlined"
                        value={tightSpreadPct.maxOptionSpreadPct}
                        onChange={(ev) =>
                            dispatchTightSpreadPct({
                                maxOptionSpreadPct: ev.target.value,
                            })
                        }
                        //    required
                    />
                </AccordionDetails>
            </Accordion>

            <Accordion expanded={optionPriceRangeEnabled}>
                <AccordionSummary
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                >
                    <FormControlLabel
                        aria-label="Acknowledge"
                        // onClick={(event) => event.stopPropagation()}
                        // onFocus={(event) => event.stopPropagation()}
                        // expanded={expanded === "additional"}
                        // onClick={(ev) => handleChange("additional")}
                        label="add option price range"
                        control={
                            <Checkbox
                                checked={optionPriceRangeEnabled}
                                onChange={(ev) =>
                                    setOptionPriceRangeEnabled(optionPriceRangeEnabled !== true)
                                }
                            />
                        }
                    />
                </AccordionSummary>
                <AccordionDetails>
                    <TextField
                        id="outlined-basic"
                        label="Min Price"
                        variant="outlined"
                        value={optionPriceRange.minPrice}
                        onChange={(ev) =>
                            dispatchOptionPriceRange({
                                minPrice: ev.target.value,
                            })
                        }
                        //      required
                    />
                    <TextField
                        id="outlined-basic"
                        label="Max Price"
                        variant="outlined"
                        value={optionPriceRange.maxPrice}
                        onChange={(ev) =>
                            dispatchOptionPriceRange({
                                maxPrice: ev.target.value,
                            })
                        }
                        //       required
                    />
                </AccordionDetails>
            </Accordion>
        </React.Fragment>
    );
};

export default OptionsFiltersTree;
